import React from 'react';
import ReactMarkdown from 'react-markdown';

export enum MIME {
    text,
    image,
    pdf,
    json
}

interface DocumentLoaderInterface {
    type?: string;
    version?: string;
    mime: MIME;
    baseURL: string;
    documentBase: string;

}

type DocumentLoaderProps = DocumentLoaderInterface

const DocumentLoader: React.FC<DocumentLoaderProps> = (props) => {

    const [url, setUrl] = React.useState('')
    const [text, setText] = React.useState('')
    const [json,setJson] = React.useState(null)


    const getExtensionFromMIME = (mine: MIME) => {
        let res = 'json';
        switch (mine) {
            case MIME.pdf:
                res = 'pdf';
                break;
            case MIME.image:
                res = 'png';
                break;
            case MIME.json:
                res = 'json';
                break;
            case MIME.text:
                res = 'md';
                break;
            default:
                break;
        }
        return res;
    }

    const loadAndSaveDocs = (mime: MIME, baseURL: string, documentBase: string) => {

        let extension: string = getExtensionFromMIME(mime);

        fetch(`/${baseURL}/${documentBase}.${extension}`)
            .then(r => {
                switch (mime) {
                    case MIME.pdf:
                        return r.blob();

                    case MIME.text:
                        return r.text();

                    case MIME.image:
                        return r.blob();

                    case MIME.json:
                        return r.json();

                    default:
                        return r.json();

                }
            })
            .then(data => {
                switch (mime) {
                    case MIME.pdf:
                        setUrl(URL.createObjectURL(data))
                        break;
                    case MIME.text:
                        setText(data);
                        break;
                    case MIME.image:
                        setUrl(URL.createObjectURL(data));
                        break;
                    case MIME.json:
                        setJson( data);
                        break;
                    default:
                        setUrl(URL.createObjectURL(data));
                        break;
                }
            })
            .catch(err => {
                console.error('Error: ', err);
            });
    }



    React.useEffect(() => {
        const { mime, baseURL, documentBase } = props;
        loadAndSaveDocs(mime, baseURL, documentBase);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props])

    const getComponent = (mime: MIME) => {
        let component = <></>;
        switch (mime) {
            case MIME.text:
                component = <ReactMarkdown>{text}</ReactMarkdown>;
                break;
            case MIME.pdf:
                component = <div>{url}</div>;
                break;
            case MIME.image:
                component =  <img alt="component-image" src={url} />;
                break;
            default:
                let res: JSON;
                if (json) {
                    res = json;
                } else {
                    res = JSON.parse('{enpty: "empty"}');
                }
                component = <span>{res.toString()}</span>;
                break;
        }
        return component;
    }

        const {mime} = props;
        let component = getComponent(mime);

        return (
           <div>{component}</div>
        );

}

export default DocumentLoader